import ApiBlockLayout from '../ApiBlockLayout'
import './ApiBlock.css'

const ApiBlock = () => {
  return (
    <ApiBlockLayout/>
  )
}

export default ApiBlock